// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay[data-v-a793790e]{align-items:center;background-color:var(--overlay-bg);display:flex;justify-content:center;position:absolute;bottom:0;top:0;left:0;right:0;text-align:center;z-index:51}.overlay-content-mode[data-v-a793790e],.overlay-main-mode[data-v-a793790e]{top:var(--header-height)}.overlay-content-mode[data-v-a793790e]{left:calc(var(--nav-width))}", ""]);
// Exports
module.exports = exports;
